import * as React from 'react'

import { MultiContext } from '../utils';

import { FormContext } from './Form';

export function useFormInfo<T = any>() {
  return React.useContext<FormContext<T>>(MultiContext).formInfo;
}